// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Planning_planning__9r45F {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.Planning_desktop__3-EJ_ {\n  min-width: 800px;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Wrapper/Planning.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".planning {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.desktop {\n  min-width: 800px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"planning": "Planning_planning__9r45F",
	"desktop": "Planning_desktop__3-EJ_"
};
export default ___CSS_LOADER_EXPORT___;
